import { StupidBaseResponse } from "../customer/walletApiRequest";
import { RDRequestsv2 } from "../httpRequest";

export interface PendoDataResponse extends StupidBaseResponse{
  IsEnabled: boolean;
  ApiKey:string;
  AccountId:string;
  VisitorIdPrefix:string;
}
const pendoApiRequest = {
  getPendoData: async ():Promise<PendoDataResponse> => {
    const response = await RDRequestsv2.get<PendoDataResponse>(
      `pendo/data`,
    );
    return response;
  },
};

export default pendoApiRequest;
